export enum EntreprisesPath {
  LISTE = '',
  EDITION = 'edition-entreprise',
  EDITION_GENERAL = 'general',
  LISTE_FACTURES = 'factures',
  LISTE_PERSONNES = 'personnes',
  CREATION = 'creation-entreprise',
  ID_ENTREPRISE_PARAM_MAP = 'idEntreprise',
  CREATION_PERSONNE = 'creation-personne',
  DOCUMENTS = 'documents',
  TACHES = 'taches',
  INSCRIPTION = 'inscription',
  ENTREPRISES_LIEES = 'entreprises-liees',
  CONTRATS = 'contrats',
}
